import "./App.css";
import Header from "./components/Header";
import Main from "./components/Main";
import { useState } from "react";

function App() {
  const [isEmpty, setIsEmpty] = useState(false);
  const [cartNumber, setCartNumber] = useState(0);

  function handleCart() {
    const cart = document.querySelector(".item-quantity").innerHTML;
    setIsEmpty((prev) => {
      if (+cart > 0) {
        return true;
      } else {
        return false;
      }
    });
    setCartNumber(cart);
  }

  return (
    <div className="App">
      <Header
        isEmpty={isEmpty}
        handleCart={handleCart}
        cartNumber={cartNumber}
      />
      <Main isEmpty={isEmpty} handleCart={handleCart} />
    </div>
  );
}

export default App;
